import React, { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import useSEO from "../../../hooks/useSEO.js";

import data from "../../../Data/staffData/staffData.json";
import publicationsData from "../../../Data/publicationsData1.json";
import publicationsData2 from "../../../Data/publicationsData2.json";
// import publicationsData2 from "../../../Data/publicationsData2.json";

const CITY = "Екатеринбург";

// ================= HELPERS =================

function detectSpecialization(person) {
  const text =
    `${person?.position || ""} ${person?.bio?.join(" ") || ""}`.toLowerCase();

  if (text.includes("дермат")) return "преподаватель дерматовенерологии";
  if (text.includes("гинек")) return "преподаватель гинекологии";
  if (text.includes("уролог")) return "преподаватель урологии";
  if (text.includes("биолог")) return "преподаватель биологии";
  if (text.includes("педагог")) return "преподаватель педагогических дисциплин";
  if (text.includes("профессор")) return "профессор";
  if (text.includes("доцент")) return "доцент";

  return "преподаватель";
}

function cleanText(text = "") {
  return text.replace(/\s+/g, " ").replace(/"/g, "").trim();
}

// ================= COMPONENT =================

export default function StaffDetail() {
  const { slug } = useParams();
  const [showPublications, setShowPublications] = useState(false);

  const person = data.find((p) => p.slug === slug);

  const isPersonFound = Boolean(person);

  const spec = detectSpecialization(person);

  // ✅ НОРМАЛИЗАЦИЯ (важно!)
  const normalize = (v) =>
    String(v || "")
      .trim()
      .toLowerCase();

  const normalizedSlug = normalize(person?.slug);

  // ================= ПУБЛИКАЦИИ (ИСПРАВЛЕНО) =================

  const personPublications = useMemo(() => {
    if (!person) return [];

    const allPublications = [
      ...(publicationsData || []),
      ...(publicationsData2 || []),
    ];

    return allPublications.filter((pub) =>
      (pub.authors || []).some(
        (author) => normalize(author) === normalizedSlug,
      ),
    );
  }, [person, normalizedSlug]);

  // ================= SEO =================

  useSEO({
    title: isPersonFound
      ? `${person.name} — ${spec} | УРНИИДВиИ`
      : "Преподаватель не найден | УРНИИДВиИ",

    description: person
      ? `${person.name} — ${spec} в ${CITY}. ${cleanText(person.position)}`
      : "Преподаватель УрНИИДВиИ.",

    url: isPersonFound
      ? `/education/teaching-staff/${person.slug}`
      : "/education/teaching-staff",

    type: "profile",
    noindex: !isPersonFound,
  });

  // ================= UI =================

  if (!person) {
    return (
      <section className="staff-detail">
        <Breadcrumbs />
        <p>Сотрудник не найден</p>
      </section>
    );
  }

  return (
    <section className="contacts education staff-detail">
      <Breadcrumbs />

      <div className="staff-detail__wrapper">
        <div className="staff-detail__photo">
          <img src={person.photo} alt={person.name} />
        </div>

        <div className="staff-detail__info">
          <h1 className="staff-detail__name">{person.name}</h1>
          <h4 className="staff-detail__position">{person.position}</h4>

          {person.bio?.length > 0 && (
            <div className="staff-detail__bio">
              {person.bio.map((b, i) => (
                <p key={i}>{b}</p>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ================= PUBLICATIONS ================= */}

      {personPublications.length > 0 && (
        <div className="staff-detail__publications">
          <button
            onClick={() => setShowPublications((p) => !p)}
            className="staff-detail__record"
          >
            {showPublications
              ? "Скрыть публикации"
              : `Показать публикации (${personPublications.length})`}
          </button>

          {showPublications && (
            <div className="staff-detail__publications-list">
              <h4 className="staff-detail__position">Научные публикации</h4>

              <ul className="staff-detail__publications-list">
                {personPublications.map((pub) => (
                  <li key={pub.id} className="staff-detail__publication">
                    <p>{pub.title}</p>

                    {pub.files?.map((file, i) => (
                      <a
                        key={i}
                        href={file.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="structure__download-link licenses__link"
                      >
                        📄 Открыть документ
                      </a>
                    ))}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </section>
  );
}
